import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoPendingActions = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint0_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M143.4 73.39A96 96 0 0 0 116 57.85c-18.09-6.7-36.43-7.7-51.75-3.91"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint1_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M156.45 147.46c4.2-4.11 7.46-9.1 9.52-14.6a41 41 0 0 0 1.6-22.38h-.03"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint2_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M95.23 161.61a84 84 0 0 0 36.92-.88"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint3_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M27.08 90.94c-2.04 16.42 6.18 34 21.35 47.76"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint4_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M28.32 48.77a26.28 26.28 0 1 0 2.67-1.67"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M57.49 78.14c.22 1.14-.4 5.21-3.14 5.21-2.57 0-3.13-3.74-3.24-4.9-9.48 1.08-19.18 5.28-21.25 14.43a26.4 26.4 0 0 0 37.92-12.06c-2.93-2.05-6.62-2.63-10.3-2.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint5_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M57.49 78.14c.22 1.14-.4 5.21-3.14 5.21-2.57 0-3.13-3.74-3.24-4.9-9.48 1.08-19.18 5.28-21.25 14.43a26.4 26.4 0 0 0 37.92-12.06c-2.93-2.05-6.62-2.63-10.3-2.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M54.5 64.33c-2.5-1.12-3.98 1.04-1.8 2.85 1.7-2.5 4.12-1.23 3.95 2.04a3.9 3.9 0 0 0-2.14-4.89"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint6_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M54.5 64.33c-2.5-1.12-3.98 1.04-1.8 2.85 1.7-2.5 4.12-1.23 3.95 2.04a3.9 3.9 0 0 0-2.14-4.89"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint7_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M57.49 78.14c-.14-1.5-.5-2.96-.94-6.88.87-.7 1.12-1.83.73-2.1a.6.6 0 0 0-.63.05c.08-1.69-.57-3.09-1.66-3.32-1.29-.26-2.68 1.2-3.12 3.3-.35 1.68.03 3.25.87 3.93q-.63 2.7-1.63 5.32c.1 1.16.67 4.92 3.24 4.91 2.74 0 3.36-4.07 3.14-5.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M52.74 73.12q-.15.62-.34 1.25c1.24.64 2.5-.6 3.1-1.94-.97 1.22-2.07 1.26-2.76.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint8_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M52.74 73.12q-.15.62-.34 1.25c1.24.64 2.5-.6 3.1-1.94-.97 1.22-2.07 1.26-2.76.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint9_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M24.4 20.44c-8.33-2.53-16.8 1.05-18.92 8-3.06 10.07 8.6 20.15 20.34 17.6l5.75 6.3-.91-8.27c9.63-6.29 5.88-19.93-6.26-23.63"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint10_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m15.42 29.95 10.3.01"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint11_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m15.42 33 10.3.01"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint12_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m15.41 36.1 10.3.01"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint13_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M155.74 42.99c-.94-6.09-7.6-10.1-14.86-8.96-10.87 1.7-15.18 12.95-8.04 19.06l-1.75 6.83 5.55-4.6c9.44 3.53 20.46-3.48 19.1-12.33"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint14_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m146.97 42.5-8.69-.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint15_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m146.93 45.09-8.69-.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint16_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m146.9 47.72-8.7-.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint17_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m163.82 156.3-11.75-2.06-9.49 5.9 16.96 2.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint18_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m168.1 149.5-6.54-1.16-9.49 5.9 11.75 2.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint19_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m190.03 129.92-10.88 5.15a10.7 10.7 0 0 0-4.5 3.99l-15.12 24.05-33.9-5.95a4.7 4.7 0 0 0 3.64 3.07l32.3 5.64 16.85-27.09 16.58-7.84a4.2 4.2 0 0 0-4.97-1.03"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint20_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m161.57 165.87 16.85-27.09 16.58-7.84-14.41 22.78z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint21_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m142.58 160.14-16.96-2.98 9.5-5.9 16.95 2.98z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint22_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m152.06 154.25-16.96-2.98 9.5-5.9 16.95 2.98z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint23_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M167.53 57.7a26.39 26.39 0 1 0 0 52.78 26.39 26.39 0 0 0 0-52.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M167 82.48c-.9-.53-1.2-1.73-.68-2.11a.8.8 0 0 1 .86.02c-.04-1.5.55-3.35 2-3.6 1.76-.18 3 1.88 3.25 3.62.36 2.15-.42 4.08-1.75 4.43.3 1.52.4 1.73 1.27 7.16a36 36 0 0 1 10.55 4.81c-4.5-10.1-9.28-21.75-13.95-22.48-3.13-.48-5.14 2.51-5.82 4.2-3.83 9.65-11.54 11.41-15.89 21.92a27 27 0 0 0 3.48 3.64c3.8-4.85 9.38-9.68 14.8-11.55.05-.24 1.67-7.86 1.88-10.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint24_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M182.5 96.81c-4.5-10.1-9.28-21.75-13.95-22.48-3.13-.48-5.14 2.51-5.82 4.2-3.83 9.65-11.54 11.41-15.89 21.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint25_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M165.12 92.53c-5.44 1.86-10.97 6.69-14.77 11.59a26.36 26.36 0 0 0 37.7-3.42c-5.14-3.98-11.37-7.68-16.1-8.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint26_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M172.43 80.41c-.25-1.74-1.5-3.8-3.26-3.61-1.44.24-2.03 2.08-2 3.59a.8.8 0 0 0-.86-.02c-.52.38-.22 1.58.69 2.1-.22 2.25-1.88 10.08-1.88 10.08l5.83 8.8 1.07-8.92c-.94-5.85-1.04-6.03-1.34-7.59 1.33-.35 2.1-2.28 1.75-4.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M167.99 83.31c.52 1.78 1.74 3 2.96 2.88l-.27-1.35a2.6 2.6 0 0 1-2.7-1.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint27_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M167.99 83.31c.52 1.78 1.74 3 2.96 2.88l-.27-1.35a2.6 2.6 0 0 1-2.7-1.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-light, #B5E897)",
			d: "M170.68 122.73c-6.45.19-8.23 2.12-1.07-1.4a1.25 1.25 0 0 0 .65-1.54 1.24 1.24 0 0 0-1.46-.8c-4.6.62-4.42 1.54-12.9 2.79-1.36-.38-.22-1.25.2-3.92q.29-1.1.34-2.22c.04-.95-1.55-1.2-2-.33-1.45 2.88-3.61 4.36-3.98 7.14-.25 1.91-2.3 2.23-4.55 2.2-6.38-.7-14.85-3.09-15.36-3.6-3.44-3.6-4.43-9.1-6.35-13.7l-8.98 4.43c.64 3.62 3.48 12.8 3.5 16.38q.03 1.35-.3 2.65a14.3 14.3 0 0 0 8.81 2.74l19.05-.5c3.27.06 4.81 2.08 10.05 1.54 3.85-.39 8.39-2.47 12.25-3.84a1.05 1.05 0 0 0-.47-2.04c-.85.02-1.03.27 1.6-.91a1.16 1.16 0 0 0 .6-1.64q-.16-.3-.46-.46l1.4-.48a1.27 1.27 0 0 0-.57-2.49"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint28_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m128.69 133.51 17.58-.46c3.28.05 4.82 2.07 10.06 1.54 3.85-.4 8.39-2.48 12.25-3.85a1.05 1.05 0 0 0 .29-1.88c-.22-.15-.5-.2-.76-.16-.86.02-1.04.28 1.6-.9a1.2 1.2 0 0 0 .75-1.02 1.2 1.2 0 0 0-.6-1.09l1.38-.48a1.28 1.28 0 0 0-.56-2.48c-6.45.18-8.23 2.12-1.07-1.41a1.24 1.24 0 0 0-.8-2.34c-4.6.62-4.43 1.55-12.91 2.8-1.36-.38-.22-1.25.2-3.92q.29-1.1.34-2.23c.04-.94-1.55-1.2-2-.32-1.45 2.88-3.61 4.35-3.98 7.14-.25 1.91-2.3 2.23-4.55 2.19-6.38-.7-14.85-3.08-15.36-3.6-3.44-3.58-4.43-9.1-6.35-13.69"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint29_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m164.99 123.42-3.89 1.05"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint30_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m169.85 125.7-7.66 1.58"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint31_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m167.54 128.73-5.33 1.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint32_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M157.79 132.48a4.9 4.9 0 0 0-3.54-3.68 7.2 7.2 0 0 0 3.4-6.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint33_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M93.72 142.48q1.48.45 3.02.23c8.2-1.39 22.08-4 21.99-14.55-.04-3.61-2.92-12.92-3.53-16.48 5.22-2.4 9-4.33 9-4.33-1.7-4.08-2.73-8.41-4.45-12.48-1.64-3.89-8.6-7.48-17.07-10.57a7.4 7.4 0 0 0-6.25.6c-4.37 2.6-9.22 4.75-13.14 7.65-3.42 2.36-5.42 5.8-7.15 9.55-1.12 2.4-2 7.17-2.69 12.42"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint34_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m89.65 114.58 1.23-6.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint35_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m115.2 111.68-.99-5.09"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-light, #B5E897)",
			d: "M131.24 141.06c-.82-2.46-1.4-6.93-4.48-10.33-2.89-3.18-17.83-8.43-39.36-2.6-.62-3.52 1.13-7.58 2.25-13.55H73.44c-.67 4.47-1.15 9.33-1.45 13.08a26.4 26.4 0 0 1 21.2 13.78 105 105 0 0 0 5.39-2.45c6.62-3.22 9.26-6.18 15.16-1.66.94.71 6.85 4.99 7.3 5.67.98 1.5 3.38 6.85 4.48 7.84a1.3 1.3 0 0 0 1.16.22 1.3 1.3 0 0 0 .89-1.62c1.01.17 2.05-.3 1.75-1.75.6.28 1.65-.09 1.23-2.41q.24.13.5.1c.97-.37 1.04-1.77.19-4.32"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint36_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M93.19 141.44a105 105 0 0 0 5.39-2.45c6.62-3.22 9.26-6.18 15.16-1.66.94.71 6.84 4.99 7.3 5.67.98 1.5 3.38 6.85 4.48 7.85a1.3 1.3 0 0 0 2.05-1.4c1 .16 2.05-.3 1.75-1.76.6.28 1.65-.08 1.23-2.41q.24.13.5.1c.97-.37 1.04-1.78.19-4.32-.82-2.46-1.4-6.93-4.48-10.34-2.89-3.18-17.83-8.42-39.36-2.58-.62-3.53 1.13-7.6 2.25-13.56H73.44c-.67 4.47-1.15 9.33-1.45 13.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint37_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M123.1 138.72c1.57 1.33 3.74 8.46 4.46 10.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint38_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M124.86 136.96c1.56 1.33 3.74 8.46 4.46 10.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint39_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M126.54 135.5c1.33 1.14 2.75 5.88 4.01 9.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-light, #B5E897)",
			d: "M101.82 73.78c1.13-1.53.79-3.43-.42-2.26-1.77-3.33-2.93-3.85-5.17-4.5 1.45 5.53-.78 8.1.94 9.7a99 99 0 0 1-.76 8.5l6.2 8.4.82-8.4a88 88 0 0 0-1.61-11.44"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint40_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.82 73.78c1.13-1.53.79-3.43-.42-2.26-1.77-3.33-2.93-3.85-5.17-4.5 1.45 5.53-.78 8.1.94 9.7a99 99 0 0 1-.76 8.5l6.2 8.4.82-8.4a88 88 0 0 0-1.61-11.44"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "m97.17 76.72-.08 1.42c1.1 1.09 4.43 1.22 4.1-3.48-.26 3.4-2.96 3-4.02 2.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint41_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m97.17 76.72-.08 1.42c1.1 1.09 4.43 1.22 4.1-3.48-.26 3.4-2.96 3-4.02 2.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M98.43 59.09c1.39 2.1 2.6 9.93 2.97 12.43-2.36-4.44-4.06-3.94-6.1-4.8a6.6 6.6 0 0 1-3.75-4.46c-1.31-4.94 4.88-6.23 6.88-3.17"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint42_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M98.43 59.09c1.39 2.1 2.6 9.93 2.97 12.43-2.36-4.44-4.06-3.94-6.1-4.8a6.6 6.6 0 0 1-3.75-4.46c-1.31-4.94 4.88-6.23 6.88-3.17"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint43_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M69.96 127.58a26.4 26.4 0 1 0 0 52.8 26.4 26.4 0 0 0 0-52.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M82.25 167.32a7.5 7.5 0 0 0 3-5.8c0-4.2-3.98-7.66-9.14-8.24 3.22-4.37-.76-10.34-7.8-10.34-6.17 0-10 4.55-8.63 8.67-9.37-1.54-15.94 6.59-11.63 12.74a9 9 0 0 0-1.88 1.06 26 26 0 0 0 5.43 7.54 37 37 0 0 1 13.26-4.17q.45-4.8.34-9.61a3.3 3.3 0 0 1-1.59-1.81.76.76 0 0 1 1.31-.5q.5.4.93.87s-.28-3.65 4.3-4.16q.9 2.6 1.23 5.33a2.06 2.06 0 0 1-1.93 2.5c.71 2.8.55 2.22 1.93 7.19q1.5.16 2.92.58c4.11 1.24 5.92 2.28 12.37 5.24q1.08-.89 2.06-1.88a8.5 8.5 0 0 0-6.48-5.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint44_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M82.25 167.32a7.5 7.5 0 0 0 3-5.8c0-4.2-3.98-7.66-9.14-8.24 3.22-4.37-.76-10.34-7.8-10.34-6.17 0-10 4.55-8.63 8.67-9.37-1.54-15.94 6.59-11.63 12.74a9 9 0 0 0-1.88 1.06 26.4 26.4 0 0 0 42.56 7.12 8.5 8.5 0 0 0-6.48-5.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint45_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M65.2 159.17a3.3 3.3 0 0 1-1.59-1.81.77.77 0 0 1 1.31-.5q.5.41.93.87s-.28-3.65 4.3-4.16q.9 2.6 1.23 5.33a2.06 2.06 0 0 1-1.93 2.5c.7 2.81.54 2.19 1.93 7.19 0 0-1.06 3.99-1.46 5.83l-5.12-5.77q.47-4.73.4-9.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M67.19 160.03a2.6 2.6 0 0 0 2.26 1.37l.26 1.04c-1.31 0-2.51-2.24-2.52-2.41"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint46_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M67.19 160.03a2.6 2.6 0 0 0 2.26 1.37l.26 1.04c-1.31 0-2.51-2.24-2.52-2.41"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint47_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m18.89 98.9 3.35 3.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint48_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m18.89 102.25 3.35-3.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint49_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m53.23 30.62 6.56 6.56"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint50_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m53.23 37.18 6.56-6.56"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M143.51 74.95a1.46 1.46 0 1 0 0-2.93 1.46 1.46 0 0 0 0 2.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint51_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M143.51 74.95a1.46 1.46 0 1 0 0-2.93 1.46 1.46 0 0 0 0 2.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M27.08 92.4a1.46 1.46 0 1 0 0-2.93 1.46 1.46 0 0 0 0 2.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint52_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M27.08 92.4a1.46 1.46 0 1 0 0-2.93 1.46 1.46 0 0 0 0 2.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue, #6A89C1)",
			d: "M95.34 163.12a1.47 1.47 0 0 0 1.5-1.47 1.46 1.46 0 1 0-1.5 1.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint53_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M95.34 163.12a1.47 1.47 0 0 0 1.5-1.47 1.46 1.46 0 1 0-1.5 1.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint54_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M124.01 91.72h5.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#no-pending-actions_svg__paint55_linear_4001_10763)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M126.54 94.25V89.2"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint0_linear_4001_10763",
				x1: 103.826,
				x2: 103.684,
				y1: 70.17,
				y2: 55.654,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint1_linear_4001_10763",
				x1: 162.441,
				x2: 159.735,
				y1: 141.96,
				y2: 117.468,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint2_linear_4001_10763",
				x1: 113.69,
				x2: 113.685,
				y1: 162.885,
				y2: 161.191,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint3_linear_4001_10763",
				x1: 37.599,
				x2: 35.086,
				y1: 131.601,
				y2: 99.777,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint4_linear_4001_10763",
				x1: 43.53,
				x2: 42.269,
				y1: 88.654,
				y2: 53.462,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint5_linear_4001_10763",
				x1: 48.819,
				x2: 48.601,
				y1: 93.953,
				y2: 81.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint6_linear_4001_10763",
				x1: 54.261,
				x2: 54.137,
				y1: 68.446,
				y2: 64.969,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint7_linear_4001_10763",
				x1: 54.318,
				x2: 53.185,
				y1: 80.753,
				y2: 69.135,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint8_linear_4001_10763",
				x1: 53.949,
				x2: 53.914,
				y1: 74.227,
				y2: 72.814,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint9_linear_4001_10763",
				x1: 20.555,
				x2: 19.731,
				y1: 47.469,
				y2: 25.572,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint10_linear_4001_10763",
				x1: 20.568,
				x2: 20.568,
				y1: 29.959,
				y2: 29.954,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint11_linear_4001_10763",
				x1: 20.566,
				x2: 20.566,
				y1: 33.009,
				y2: 33.003,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint12_linear_4001_10763",
				x1: 20.563,
				x2: 20.563,
				y1: 36.111,
				y2: 36.106,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint13_linear_4001_10763",
				x1: 142.594,
				x2: 141.979,
				y1: 56.037,
				y2: 38.575,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint14_linear_4001_10763",
				x1: 142.626,
				x2: 142.625,
				y1: 42.486,
				y2: 42.398,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint15_linear_4001_10763",
				x1: 142.586,
				x2: 142.586,
				y1: 45.07,
				y2: 44.981,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint16_linear_4001_10763",
				x1: 142.546,
				x2: 142.546,
				y1: 47.698,
				y2: 47.609,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint17_linear_4001_10763",
				x1: 153.198,
				x2: 153.109,
				y1: 161.794,
				y2: 155.845,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint18_linear_4001_10763",
				x1: 160.083,
				x2: 159.988,
				y1: 155.119,
				y2: 149.785,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint19_linear_4001_10763",
				x1: 160.311,
				x2: 159.854,
				y1: 160.463,
				y2: 136.092,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint20_linear_4001_10763",
				x1: 178.285,
				x2: 177.409,
				y1: 160.675,
				y2: 137.286,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint21_linear_4001_10763",
				x1: 138.849,
				x2: 138.777,
				y1: 158.815,
				y2: 152.866,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint22_linear_4001_10763",
				x1: 148.324,
				x2: 148.252,
				y1: 152.93,
				y2: 146.981,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint23_linear_4001_10763",
				x1: 167.534,
				x2: 166.268,
				y1: 102.632,
				y2: 67.287,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint24_linear_4001_10763",
				x1: 164.67,
				x2: 164.209,
				y1: 96.558,
				y2: 79.025,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint25_linear_4001_10763",
				x1: 169.195,
				x2: 168.978,
				y1: 107.739,
				y2: 95.349,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint26_linear_4001_10763",
				x1: 168.816,
				x2: 166.886,
				y1: 97.693,
				y2: 81.455,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint27_linear_4001_10763",
				x1: 169.469,
				x2: 169.402,
				y1: 85.77,
				y2: 83.839,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint28_linear_4001_10763",
				x1: 148.188,
				x2: 147.814,
				y1: 130.614,
				y2: 112.298,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint29_linear_4001_10763",
				x1: 163.044,
				x2: 163.037,
				y1: 124.312,
				y2: 123.609,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint30_linear_4001_10763",
				x1: 166.021,
				x2: 166.013,
				y1: 127.046,
				y2: 125.98,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint31_linear_4001_10763",
				x1: 164.879,
				x2: 164.873,
				y1: 129.659,
				y2: 128.925,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint32_linear_4001_10763",
				x1: 156.018,
				x2: 155.366,
				y1: 131.014,
				y2: 124.47,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint33_linear_4001_10763",
				x1: 98.827,
				x2: 97.187,
				y1: 134.017,
				y2: 94.581,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint34_linear_4001_10763",
				x1: 90.264,
				x2: 89.42,
				y1: 113.586,
				y2: 109.259,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint35_linear_4001_10763",
				x1: 114.707,
				x2: 114.099,
				y1: 110.926,
				y2: 107.624,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint36_linear_4001_10763",
				x1: 101.91,
				x2: 101.375,
				y1: 145.677,
				y2: 121.197,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint37_linear_4001_10763",
				x1: 125.331,
				x2: 124.716,
				y1: 147.852,
				y2: 140.71,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint38_linear_4001_10763",
				x1: 127.086,
				x2: 126.471,
				y1: 146.094,
				y2: 138.952,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint39_linear_4001_10763",
				x1: 128.546,
				x2: 127.978,
				y1: 143.824,
				y2: 137.322,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint40_linear_4001_10763",
				x1: 99.832,
				x2: 97.514,
				y1: 89.667,
				y2: 72.143,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint41_linear_4001_10763",
				x1: 99.152,
				x2: 99.055,
				y1: 78.153,
				y2: 75.406,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint42_linear_4001_10763",
				x1: 96.384,
				x2: 95.91,
				y1: 69.428,
				y2: 60.012,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint43_linear_4001_10763",
				x1: 69.956,
				x2: 68.69,
				y1: 172.515,
				y2: 137.168,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint44_linear_4001_10763",
				x1: 67.451,
				x2: 66.662,
				y1: 174.791,
				y2: 149.731,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint45_linear_4001_10763",
				x1: 67.52,
				x2: 66.197,
				y1: 171.323,
				y2: 157.471,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint46_linear_4001_10763",
				x1: 68.45,
				x2: 68.395,
				y1: 162.081,
				y2: 160.466,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint47_linear_4001_10763",
				x1: 20.563,
				x2: 20.483,
				y1: 101.753,
				y2: 99.511,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint48_linear_4001_10763",
				x1: 20.563,
				x2: 20.483,
				y1: 101.753,
				y2: 99.511,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint49_linear_4001_10763",
				x1: 56.514,
				x2: 56.356,
				y1: 36.203,
				y2: 31.809,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint50_linear_4001_10763",
				x1: 56.514,
				x2: 56.356,
				y1: 36.204,
				y2: 31.809,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint51_linear_4001_10763",
				x1: 143.515,
				x2: 143.445,
				y1: 74.511,
				y2: 72.55,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint52_linear_4001_10763",
				x1: 27.08,
				x2: 27.01,
				y1: 91.961,
				y2: 90.001,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint53_linear_4001_10763",
				x1: 95.38,
				x2: 95.31,
				y1: 162.683,
				y2: 160.722,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint54_linear_4001_10763",
				x1: 126.542,
				x2: 126.537,
				y1: 92.574,
				y2: 91.903,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "no-pending-actions_svg__paint55_linear_4001_10763",
				x1: 127.042,
				x2: 126.447,
				y1: 93.501,
				y2: 90.216,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			})
		] })
	]
});
export default SvgNoPendingActions;
